<template>
  <b-dropdown-group>
    <b-dropdown-text
      class="bg-white py-2 border-bottom position-sticky top-0"
      text-class="py-0 px-3 d-flex justify-content-end flex-wrap"
    >
      <slot name="top" />

      <BaseSearchInput v-model="keyword" />
    </b-dropdown-text>

    <slot v-bind="{ options: optionItems }">
      <b-list-group v-if="!!optionItems.length" class="position-relative" flush>
        <b-list-group-item
          v-for="optionItem in optionItems"
          :key="`advanced-dropdown-item-${optionItem.value}`"
          :active="value.includes(optionItem.value)"
          :disabled="optionItem.disabled"
          class="py-2"
          :class="{
            h5: 'sm' === size,
            h4: 'lg' === size
          }"
          action
          @click.stop="() => handleSelectItem(optionItem)"
        >
          <span class="advanced-dropdown-item-text">
            {{ optionItem.text }}
          </span>

          <slot
            name="item-extra"
            v-bind="{
              ...optionItem,
              selected: value.includes(optionItem.value)
            }"
          />
        </b-list-group-item>
      </b-list-group>

      <b-dropdown-text v-else text-class="px-3 small"
        >No items found.</b-dropdown-text
      >
    </slot>

    <slot name="footer" />
  </b-dropdown-group>
</template>

<script>
import { defineComponent, inject, computed, ref } from '@vue/composition-api'
import Fuse from 'fuse.js'

import { BaseSearchInput } from '@components/base'

import { advancedDropdownInjectionKey } from './AdvancedDropdown.constants'

export default defineComponent({
  name: 'AdvancedDropdownItems',
  components: {
    BaseSearchInput
  },
  emits: ['select'],
  setup(_, { emit }) {
    const { value, options, size } = inject(advancedDropdownInjectionKey)

    const keyword = ref('')

    const MAX_RENDER = 200

    const optionItems = computed(() => {

      if (!keyword.value) {
        return options.value.slice(0, MAX_RENDER)
      }

      const fuse = new Fuse(options.value, {
        keys: ['text'],
        useExtendedSearch: true
      })

      const results = fuse.search(`'${keyword.value}`).map(({ item }) => item)

      return results.slice(0, MAX_RENDER)
    })

    const handleSelectItem = (option) => {
      if (option.disabled) return

      emit('select', option)
    }

    return {
      value,
      size,

      keyword,
      optionItems,
      handleSelectItem
    }
  }
})
</script>

<style scoped>
ul[role='group'] >>> .list-group {
  z-index: 0;
}

ul[role='group'] >>> .list-group-item {
  cursor: pointer;
}
</style>
